module.exports = "<svg class=\"menu-button-support-icon-arrow\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4 6h9l-4.5 5\" fill=\"#999\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/caret-down.svg
// module id = 88
// module chunks = 0 1